export default __webpack_public_path__ + "static/media/pic (8).31270e62.jpg";